// api/order.js
import axios from "axios";
import config from "../config";

export const getOrderById = async (orderId) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${config.apiBaseUrl}/Order/admin-order-detail/${orderId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy chi tiết đơn hàng (admin):", error);
    throw error;
  }
};

/**
 * Tạo đơn hàng tại quầy (POS)
 * payload:
 * {
 *   customer: { name, phone, email, address },
 *   note: string,
 *   paymentMethod: "cash" | "banking" | "card" | ...,
 *   discount: { type: "percent" | "amount", value: number },
 *   items: [
 *     { productId, variantId, color, size, quantity }
 *   ]
 * }
 */
export const createPosOrder = async (payload) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const res = await axios.post(
    `${config.apiBaseUrl}/order/create-pos`,
    payload,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
      },
    }
  );
  return res.data; // { orderId: 123 }
};
